import React from "react";

import { UserApi } from "api-client/apis/UserApi";
import { Employee } from "api-client/models/Employee";

import { getAuthConfiguration } from "utils/getAuthConfiguration";

import LoadingSpinner from "components/Loaders/LoadingSpinner";
import { LoadingSpinnerSize } from "types/loadingSpinner";
import { Provider } from "react-redux";
import { App } from "./App";
import store from "config/store";

interface AppLoaderProps {
    apiBaseUrl: string;
}

export const AppLoader: React.FC<AppLoaderProps> = ({ apiBaseUrl }) => {
    const [profile, setProfile] = React.useState<Employee | undefined>();
    React.useEffect(() => {
        async function loadProfile() {
            const userApi = new UserApi(getAuthConfiguration(apiBaseUrl));
            const response = await userApi.getMyProfileApiUserMyProfileGet();
            setProfile(response);
        }

        if (apiBaseUrl) {
            loadProfile();
        }
    }, []);

    if (!profile) {
        return <LoadingSpinner size={LoadingSpinnerSize.large} absoluteCenter={true} />;
    }

    return <ConnectedApp apiBaseUrl={apiBaseUrl} profile={profile} />;
};

interface ConnectedAppProps {
    profile: Employee;
    apiBaseUrl: string;
}
const ConnectedApp: React.FC<ConnectedAppProps> = ({ apiBaseUrl, profile }) => {
    return (
        <Provider store={store}>
            <App apiBaseUrl={apiBaseUrl} profile={profile} />
        </Provider>
    );
};
